export const activeUsersFilterOptions = [
  { label: 'Usuários Ativos', value: false },
  { label: 'Usuários Inativos', value: true },
];

export const activeStoresFilterOptions = [
  { label: 'Lojas Ativas', value: false },
  { label: 'Lojas Inativas', value: true },
];

export const gatewayOptions = [
  { value: '', label: 'Nenhum' },
  { value: 'pagarme', label: 'Pagar.me v5' },
  { value: 'pagarme_hub', label: 'Pagar.me HUB' },
  { value: 'cielo', label: 'Cielo' },
  { value: 'justa', label: 'Justa' },
];

export const externalGatewayOptions = [
  { value: '', label: 'Nenhum' },
  { value: 'pagarme', label: 'Pagar.me v4' },
  { value: 'rede', label: 'Rede' },
  { value: 'mercadopago', label: 'Mercado Pago' },
  { value: 'pagseguro', label: 'PagSeguro' },
];

export const bnplGatewayOptions = [
  { value: '', label: 'Nenhum' },
  { value: 'koin', label: 'Koin' },
];

export const deliveryStatuses = [
  { value: 'BEE', label: 'Bee' },
  { value: 'MOTTU', label: 'Mottu' },
  { value: 'UBER', label: 'Uber' },
  { value: 'CORREIOS', label: 'Correios' },
  { value: 'CORREIOS_EXPRESS', label: 'Correios Express' },
  { value: 'VIDDY_DELIVERIES', label: 'Viddy Entregas' },
  { value: 'LALAMOVE', label: 'Lalamove' },
  { value: 'ENTREGA99', label: '99Entrega' },
  { value: 'IFOOD_ENVIOS', label: 'iFood Envios' },
  { value: 'PROPRIA', label: 'Alternativa' },
];

export const salesSubStatuses = [
  { value: '0|OPEN', label: 'Carrinho Aberto' },
  { value: '0|ON_PROCESSING', label: 'Pedido em Processamento' },
  {
    value: '0|AUTOMATICALLY_REJECTED',
    label: 'Pagamento rejeitado automaticamente',
  },
  { value: '0|REJECTED_FOR_HIGH_FRAUD_RISK', label: 'Risco Alto de Fraude' },
  { value: '0|REJECTED_FOR_MEDIUM_FRAUD_RISK', label: 'Risco Médio de Fraude' },
  {
    value: '0|AUTHORIZED_WITH_LOW_FRAUD_RISK',
    label: 'Autorizado com Risco Baixo de Fraude',
  },
  {
    value: '0|DENIED_BY_CARD_PROVIDER',
    label: 'Negado pela fornecedora do cartão',
  },
  { value: '0|LIMIT_RETURN_CLIENT', label: 'Limite Estornado' },
  {
    value: '0|REJECTED_FOR_ACQUIRER',
    label: 'Pagamento rejeitado pelo adquirente',
  },
  { value: '0|REJECTED', label: 'Pagamento rejeitado' },
  { value: '0|IN_FRAUD_ANALYSIS', label: 'Análise de Fraude' },
  { value: '0|ANALYSIS_FAILED', label: 'Análise Reprovada' },
  { value: '0|ANALYSIS_APPROVED', label: 'Análise Aprovada' },
  {
    value: '0|REJECTED_FOR_FRAUD',
    label: 'Pagamento rejeitado pelo anti-fraude',
  },
];

export const salesStatuses = [
  { value: 0, label: 'Não finalizado', name: '' },
  { value: 1, label: 'Aguardando pagamento', name: 'Em pagamento' },
  {
    value: 14,
    label: 'Aguardando Aceite',
    name: 'WAITING_FOR_ACCEPTANCE',
  },
  { value: 2, label: 'Pagamento Confirmado' },
  {
    value: 3,
    label: 'Aguardando entrega/retirada',
  },
  { value: 4, label: 'Entregue' },
  { value: 6, label: 'Cancelado' },
  {
    value: 7,
    label: 'Pagamento recusado automaticamente',
    name: 'AUTOMATICALLY_REJECTED',
  },
  { value: 8, label: 'Risco baixo', name: 'AUTHORIZED_WITH_LOW_FRAUD_RISK' },
  {
    value: 9,
    label: 'Risco moderado',
    name: 'REJECTED_FOR_MEDIUM_FRAUD_RISK',
  },
  { value: 10, label: 'Risco alto', name: 'REJECTED_FOR_HIGH_FRAUD_RISK' },
  { value: 11, label: 'Negado', name: 'DENIED_BY_CARD_PROVIDER' },
  { value: 12, label: 'Pendente' },
  {
    value: 13,
    label: 'Chargeback Solicitado',
    name: 'CHARGEDBACK',
  },
];

export const referralCodesOrdenations = [{ value: true, label: 'Usos' }];

export const exportTypes = [
  // { value: 'salesFromCurrentMonth', label: 'Vendas finalizadas no mês atual' },
  // {
  //   value: 'salesFromLastQuarter',
  //   label: 'Vendas finalizadas nos últimos 3 meses',
  // },
  // { value: 'salesFromCurrentYear', label: 'Vendas finalizadas no ano' },
  // {
  //   value: 'allSalesFromLastQuarter',
  //   label: 'Todas as vendas nos últimos 3 meses',
  // },
  // { value: 'users-clients', label: 'Clientes Fidelizados' },
  { value: 'salesByDate', label: 'Vendas' },
  { value: 'chargesByDate', label: 'Pagamentos' },
  { value: 'deliveriesByDate', label: 'Logística' },
  { value: 'users', label: 'Usuários' },
  { value: 'storesByDate', label: 'Lojas' },
];
